<div>
  <form class="example-form" #f="ngForm">
    <mat-card class="example-card" style="height: 300px">
      <mat-card-content>
        <!------------ bare de chargement ----------------->
        <div *ngIf="exist; else attente"></div>
        <ng-template #attente>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>

        <div class="btn">
          <div>
            <mat-form-field appearance="outline" style="margin-right: 10px">
              <mat-label>Type</mat-label>
              <mat-select
                name="CRMActivityType"
                #CRMActivityType="ngModel"
                [(ngModel)]="echange.CRMActivity_Type"
                placeholder="Type"
                required
              >
                <mat-option
                  *ngFor="let type of CRMActivity_Type"
                  [(ngModel)]="type.type_value"
                >
                  {{ type.type_texte }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="data.type == 'client'">
              <mat-label>Interlocuteur</mat-label>
              <mat-select
                name="avtAlerteInterlocuteur"
                #avtAlerteInterlocuteur="ngModel"
                required
                [(ngModel)]="echange.TiersC_Id"
                placeholder="Interlocuteur"
              >
                <mat-option
                  *ngFor="let c of datasourceInterlocuteur"
                  [value]="c.TiersC_Id"
                  >{{ c.TiersC_Nom }} {{ c.TiersC_PreNom }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <!------------ bouton ----------------->
          <div>
            <button
              (click)="enregistrer(f)"
              [disabled]="dsabledBtnEnregister"
              type="submit"
              mat-raised-button
              class="colorGreen"
            >
              <mat-icon>save</mat-icon>Enregistrer
            </button>
            <button (click)="close()" mat-raised-button class="colorRed">
              <mat-icon>close</mat-icon>Fermer
            </button>
          </div>

          <!-- <div class="button-row">
            <button (click)="uploadFile()" mat-raised-button *ngIf="initDoc != undefined"  class="colorGreen">Associer un document</button>
          </div>  -->
        </div>
        <!-- ----------------type echange -------------------->

        <!-- ----------------Ajouter fichier -------------------->
        <!-- <input id="fileToUpload" style="display: none;" type="file" (change)="onChangeImagefile($event)">        
        <span style="margin-left: 15px;"><span style="font-weight: bold;">Document: </span> {{imageName}}</span>
        <mat-icon *ngIf="haveFile" color="primary" style="cursor: pointer;margin-left: 10px;" (click)="telecharger()" >cloud_download</mat-icon> -->
        <!-- ----------------texte echange -------------------->
        <!-- <ckeditor [config]="{}" name="Perso_A1" #Perso_A1="ngModel" [(ngModel)]="echange.CRMActivity_Description" required></ckeditor> -->
        <!-- Angular Editor Supprimer -->
        <!-- <angular-editor [config]="editorConfig" name="Perso_A1" placeholder=" " #Perso_A1="ngModel" [(ngModel)]="echange.CRMActivity_Description"></angular-editor> -->
        <app-editor
          [id]="'editot-text1'"
          (outputAction)="editorAction($event)"
          #editor
          [config]="configInfoBasPage"
        ></app-editor>

        <!-- ----------------gestion de fichier -------------------->
        <!-- <div class="example-button-row">
            <button matTooltip="Ajouter" style="margin-right: 10px" mat-icon-button [disabled]="buttonDisabled" (click)="importer('666_450')"  color="primary">
                <mat-icon aria-label="Example icon-button with a heart icon">cloud_upload</mat-icon>
            </button>
            <button matTooltip="Modifier" mat-icon-button [disabled]="buttonDisabled"  (click)="importer('modifier_666_450')"  color="primary">
                <mat-icon aria-label="Example icon-button with a heart icon">edit</mat-icon>
            </button>
            <button matTooltip="Ajouter" mat-icon-button [disabled]="buttonDisabled" color="primary">
                <mat-icon aria-label="Example icon-button with a heart icon">delete</mat-icon>
            </button>
            <input id="input_666_450" type="file" value="importer" style="display:none;" (change)="onChangeImagefile2($event,'ajouter')">
            <input id="input_modifier_666_450" type="file" value="importer" style="display:none;" (change)="onChangeImagefile2($event,'modifier')">
        </div>
        <div *ngIf="haveFile">
            <div *ngFor="let file of listeFile;let i = index" style="cursor: pointer;margin-right: 10px" >
              <div [id]="file.File_Id" (click)="selectFile(file.File_Id)">
                <mat-icon color="primary" style="cursor: pointer;margin-left: 10px;" (click)="telecharger(file)" >insert_drive_file</mat-icon>
                <span style="margin-left: 15px;">{{file.File_Text}}</span>  
              </div>
            </div>
        </div> -->
      </mat-card-content>
    </mat-card>
  </form>
</div>
